import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import { AuthProvider } from "./utils/AuthContext";
import theme from "./config/theme";
import "./index.css";
import "./locales/i18n";
import LogIn from "./components/auth/LogIn";
import RegisterUser from "./components/auth/RegisterUser";
import QuickStartApplicant from "./components/applicants/QuickStartApplicant";
import Applicants from "./components/applicants/Applicants";
import ApplicantForm from "./components/applicants/ApplicantForm";
import ApplicantView from "./components/applicants/ApplicantView";
import DeleteApplicant from "./components/applicants/DeleteApplicant";
import LogOut from "./components/auth/LogOut";
import PremiumUpgrade from "./components/premium/PremiumUpgrade";
import SubscriptionPayment from "./components/subscription/SubscriptionPayment";
import ChangePassword from "./components/auth/ChangePassword";
import NotificationSettings from "./components/settings/NotificationSettings";
import Users from "./components/users/Users";
import VerifyEmail from "./components/auth/VerifyEmail";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import Landing from "./components/home/Landing";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ConfigProvider theme={theme}>
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LogIn />} />
          <Route path="/registeruser" element={<RegisterUser />} />
          <Route path="/quickstart" element={<QuickStartApplicant />} />
          <Route path="/applicants" element={<Applicants />} />
          <Route path="/applicant-form" element={<ApplicantForm />} />
          <Route path="/viewapplicant" element={<ApplicantView />} />
          <Route path="/view-applicant/:id" element={<ApplicantView />} />
          <Route path="/deleteapplicant" element={<DeleteApplicant />} />
          <Route path="/logout" element={<LogOut />} />
          <Route path="/premium-upgrade" element={<PremiumUpgrade />} />
          <Route path="/subscription" element={<SubscriptionPayment />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/notification-settings" element={<NotificationSettings />} />
          <Route path="/users" element={<Users />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </Router>
    </AuthProvider>
  </ConfigProvider>
);
